
import { renderHTML } from '@app/vue/Utils/editorjs-viewer';
import SwiperBigGalleryWidget from '@app/modules/widget/swiper/big-gallery';
import SwiperCarouselFixHeightWidget from '@app/modules/widget/swiper/carousel-fix-height';
export default {
    props: ['data'],
    mounted() {
        this.content = renderHTML(this.data.blocks);
        this.$nextTick(function () {
            new SwiperBigGalleryWidget().init();
            new SwiperCarouselFixHeightWidget().init();
        });
    },
    data() {
        return {
            content: '',
        };
    },
};
